import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './AccountOrderDetails';

const AccountOrderDetailsSuspense = dynamic(
	() => import('./AccountOrderDetails'),
	{ loading: () => <BlockLoadingSpinner /> },
);

export default function DynamicAccountOrderDetails(props: Props) {
	return <AccountOrderDetailsSuspense {...props} />;
}
DynamicAccountOrderDetails.displayName = 'DynamicAccountOrderDetails';
